import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är gårdsförsäljning enligt det nya regelverket 2026?";
const SHORT_ANSWER = "Gårdsförsäljning är direkt försäljning av alkoholdrycker från små producenter (vingård, mikrobryggeri, destilleri) till besökare på den egna produktionsanläggningen.";

export const Route = createFileRoute("/fraga/vad-ar-gardsforsaljning-2026")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är gårdsförsäljning enligt det nya regelver…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Förslaget bygger på prop. 2025/26:21 och är tänkt att underlätta för svenska småproducenter att sälja egna produkter direkt till besökare. Försäljningsvolymer per kund och dag begränsas."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning", label: "Gårdsförsäljning – komplett hubb" }}
      related={[{"to": "/fraga/vem-far-salja-pa-gardsforsaljning", "label": "Vem får sälja alkohol via gårdsförsäljning?"}, {"to": "/fraga/hur-mycket-far-jag-salja-per-besokare", "label": "Hur mycket alkohol får jag sälja per besökare vid gårdsförsäljning?"}, {"to": "/fraga/hur-mycket-kostar-tillfalligt-tillstand", "label": "Vad kostar ett tillfälligt serveringstillstånd?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är gårdsförsäljning enligt det nya regelverket 2026?" },
      { name: "description", content: "Gårdsförsäljning är direkt försäljning av alkoholdrycker från små producenter (vingård, mikrobryggeri, destilleri) till besökare på den egna produktionsanläg…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-gardsforsaljning-2026" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-gardsforsaljning-2026" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-gardsforsaljning-2026",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är gårdsförsäljning enligt det nya regelver…", url: "https://alkoholprovet.se/fraga/vad-ar-gardsforsaljning-2026" },
      ]),
    ],
  }),
});
